import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { t } from 'i18next';

import {
  cropConnectApiClient,
  DeliveryPlanDto,
} from '../services/cropConnectApiClient';
import { TranslationKeys } from '../i18n/locales/defaultResources';

interface DeliveryPlanState {
  deliveryPlan?: DeliveryPlanDto | null;
  isLoading: boolean;
  error?: string;
  serviceProviderData: { [key: string]: string };
  fetchDeliveryPlans: () => Promise<void>;
  deliveryPlanServiceProviderData: (id: string) => Promise<string>;
}

export const useDeliveryPlanStore = create<DeliveryPlanState>()(
  devtools((set, get) => ({
    deliveryPlan: null,
    isLoading: false,
    serviceProviderData: {},
    fetchDeliveryPlans: async () => {
      try {
        set({ isLoading: true });
        const response = await cropConnectApiClient.getMyDeliveryPlan();

        if (response.success && response.data) {
          // If response.data is an array, pick the first element
          const deliveryPlanData = Array.isArray(response.data)
            ? response.data[0]
            : response.data;

          set({
            deliveryPlan: deliveryPlanData,
          });
        } else {
          set({ deliveryPlan: null });
        }
      } catch (error) {
        console.error('Error fetching delivery plans:', error);
        set({
          error: 'No delivery plans available',
        });
      } finally {
        set({ isLoading: false });
      }
    },

    deliveryPlanServiceProviderData: async (id: string) => {
      try {
        const existingData = get().serviceProviderData;
        if (existingData[id]) {
          return existingData[id];
        }

        const response =
          await cropConnectApiClient.getDeliveryPlanProviderInfo(id);
        if (response.success) {
          existingData[id] = response.data?.additionalInfo ?? '';
          set({
            serviceProviderData: existingData,
          });
          return response.data?.additionalInfo ?? '';
        }
        return t(TranslationKeys.no_additional_data_for_provider);
      } catch (e) {
        console.error(e);
        return t(TranslationKeys.no_additional_data_for_provider);
      }
    },
  }))
);
